/*
  Awesome Aminos | standard subscription buy box (snippets/aminos-sub-widget.liquid).
  Rahi's RU Widget Test widget (RetainUp, "Step 2 V2, navy"), lifted out of its Custom
  Liquid block so every page renders the same box. Logic is his, unchanged, except:
  - one init per .asw[data-asw] root, so a page can carry more than one widget;
  - a tier can carry `units` (the 3 months plan on a single variant posts qty x 3);
  - D.offer picks the offer structure (Warren's doc, Oct 5):
      'best-deal'  3 months (the Best deal), 1 month, one-time
      'standard'   1 month, one-time
      'aggressive' first-offer test: 1 month at a fixed price (D.ag) with the welcome kit, and a
                   one-time anchor sold from a hidden copy of the product
    'promo' (buy 2, get 1 free) is reserved until that Shopify discount exists;
  - one-time is a collapsing card in the same navy system, not the underlined link
    under the button: one-time still has to look like the rest of the box.
*/
(function(){
function init(root){
  if (root.hasAttribute('data-asw-ready')) return;
  var dataEl = document.getElementById('asw-data-' + root.getAttribute('data-asw'));
  if (!dataEl) return;
  var D;
  try { D = JSON.parse(dataEl.textContent); } catch (e) { return; }
  root.setAttribute('data-asw-ready', '');

  var BUNDLE_LIVE = true; 
  // Extra points off the full price for 2+ (40% -> 45%, 25% -> 30%), not 5% of the plan price
  // (that only reaches 43% / 28%). Shopify needs a matching fixed code: $3.50 a pack adults, $3.00 kids.
  var BUNDLE = {three: 0.05, one: 0.05};
  var DUO = D.kids ? 'DUOKIDS' : 'DUOADULTS';
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var PACK = 28;
  // Gummies in one daily pack: 6 for adults, 4 for kids (each page's "How to enjoy").
  var PER = D.kids ? 4 : 6;

  var N = '#1F2A4A', F = '#E9ECF4';
  var TICK = '<svg viewBox="0 0 24 24" width="17" height="17" fill="none" stroke="'+N+'" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M4.5 12.5l4.8 4.8L19.5 7"/></svg>';
  var SHIP = '<svg viewBox="0 0 64 64" aria-hidden="true"><circle cx="32" cy="32" r="32" fill="#FFE7D6"/>'
    + '<path d="M6 25h9M3 31h12M7 37h8" stroke="#FF7722" stroke-width="3" stroke-linecap="round"/>'
    + '<rect x="15" y="20" width="24" height="20" rx="3.5" fill="#FF7722"/>'
    + '<path d="M39 25h8.5l7 7.5V40H39z" fill="#1F2A4A"/><rect x="42" y="28" width="6" height="5" rx="1" fill="#BFD4F2"/>'
    + '<circle cx="22" cy="42" r="5.5" fill="#1F2A4A"/><circle cx="22" cy="42" r="2.2" fill="#fff"/>'
    + '<circle cx="47" cy="42" r="5.5" fill="#1F2A4A"/><circle cx="47" cy="42" r="2.2" fill="#fff"/></svg>';
  
  var ART = {
    book: '<svg viewBox="0 0 48 48" fill="none" stroke="'+N+'" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><rect x="10" y="6" width="28" height="36" rx="3" fill="'+F+'"/><path d="M17 16h14M17 23h14M17 30h9"/></svg>',
    chart:'<svg viewBox="0 0 48 48" fill="none" stroke="'+N+'" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><rect x="7" y="8" width="34" height="33" rx="3" fill="'+F+'"/><path d="M7 17h34M18 17v24M29 17v24M7 29h34"/></svg>',
    gift: '<svg viewBox="0 0 48 48" fill="none" stroke="'+N+'" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><rect x="7" y="19" width="34" height="22" rx="3" fill="'+F+'"/><path d="M7 26h34M24 19v22"/><path d="M24 19s-6-12-11-9 4 9 11 9zM24 19s6-12 11-9-4 9-11 9z"/></svg>'
  };

  
  var GIFTS = {
    ship:  {l:'Free shipping', note:'On every order', art:SHIP},
    chart: {l:'Free reward sticker chart', h:'free-awesome-everyday-kids-habit-tracker-stickers', id:67591197982957, art:ART.chart},
    // Named after the guide itself (Noah, Oct 12), not Rahi's generic "Free PDF book".
    kbook: {l:'Free “Kids Run On Awesome” Guide', h:'kids-run-on-awesome-guide', id:50709648048365, art:ART.book},
    abook: {l:'Free “Adults Run On Awesome” Guide', h:'adults-run-on-awesome-guide', id:50709652635885, art:ART.book},
    myst:  {l:'Chance to win an Oura Ring', h:'chance-to-win-a-mystery-prize', id:67597675495661, art:ART.gift}
  };
  var GD = D.gifts || {};
  function gd(k){
    var g = GIFTS[k], d = g.h ? GD[g.h] : null;
    return {label:g.l, note:g.note, art:g.art, img:(d && d.img) || null, value:(d && d.value) || 0, id:(d && d.id) || g.id || null};
  }
  var offer = D.offer === 'standard' || D.offer === 'aggressive' ? D.offer : 'best-deal';
  // Aggressive offer: fixed subscription prices and their codes, and the hidden one-time product.
  var AG = offer === 'aggressive' && D.ag ? D.ag : null;

  var KIT = D.kids ? {three:['ship','chart','kbook'], one:['ship']} : {three:['ship','abook','myst'], one:['ship']};
  // The tier that carries the welcome kit. The aggressive offer has no 3 months, so the monthly plan gets it.
  var KIT_KEY = 'three';
  if (AG) { KIT = {one:['ship','abook','myst']}; KIT_KEY = 'one'; }
  // Drop sold-out gifts: Shopify rejects the whole cart/add if one item is sold out.
  function inStock(k){ var g = GIFTS[k], d = g.h ? GD[g.h] : null; return !(d && d.available === false); }
  KIT[KIT_KEY] = KIT[KIT_KEY].filter(inStock);
  
  var KIT_ADD = KIT[KIT_KEY].map(gd).map(function(x){ return x.id; }).filter(Boolean);

  var tiers = [];
  if (AG) {
    // Strikethrough and Save % are measured against the one-time anchor ($44 of $79.99 = 45%).
    // Without the hidden product the anchor falls back to D.ag.anchor and one-time is left out,
    // so the page never shows a one-time price it can't charge.
    var anchor = AG.otp ? AG.otp.price : AG.anchor;
    if (D.one && D.one.plan && AG.sub && anchor) tiers.push({key:'one', months:1, band:'Best offer',
      v:{id:D.one.id, price:anchor, available:D.one.available, plan:D.one.plan, sub:AG.sub}});
    if (AG.otp) tiers.push({key:'otp', months:1, v:AG.otp});
  } else {
    if (offer === 'best-deal' && D.three && D.three.plan && D.three.sub) tiers.push({key:'three', months:3, v:D.three, band:'Best deal'});
    if (D.one && D.one.plan && D.one.sub) tiers.push({key:'one', months:1, v:D.one, band:'Most popular'});
    if (D.one) tiers.push({key:'otp', months:1, v:D.one});
  }
  if (!tiers.length) { root.innerHTML = '<p class="asw-err">No plans found on this product.</p>'; return; }

  var st = {sel: tiers[0].key, qty: 1, busy: false, err: ''};
  var noun = D.kids ? 'kids' : 'adults';

  function m(c)  { var n = c / 100; return '$' + (Math.round(c) % 100 === 0 ? n.toFixed(0) : n.toFixed(2)); }
  function m2(c) { return '$' + (c / 100).toFixed(2); }
  function esc(s){ return String(s).replace(/[&<>"]/g, function(c){ return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c]; }); }
  function tier(k){ for (var i = 0; i < tiers.length; i++) if (tiers[i].key === k) return tiers[i]; }
  function pic(x){ return x.img ? '<img src="'+esc(x.img)+'" alt="'+esc(x.label)+'" loading="lazy" width="160" height="160">' : x.art; }
  function val(x){
    if (x.value) return '<span class="asw-tval"><s>'+m(x.value)+'</s><b>Free</b></span>';
    if (x.note) return '<span class="asw-tval">'+x.note+'</span>';
    return '<span class="asw-tval"><b>Free</b></span>';
  }

  function calc(t){
    var q = st.qty, b = (BUNDLE_LIVE && q >= 2) ? (BUNDLE[t.key] || 0) : 0;
    // 2+ people: 5% off the subscription price (Warren's doc, Oct 29: $51.99 -> $49.39, $42 -> $39.90,
    // $42.25 -> $40.14, $36 -> $34.20), matching the flat duo plans. Was 5 points off the anchor.
    var each = b ? Math.round(t.v.sub * (1 - b)) : t.v.sub;
    // Aggressive offer: 2+ is its own fixed price ($40 = 50% off), not 5 points off.
    if (AG) { b = q >= 2 && AG.duo ? 1 : 0; each = b ? AG.duo : AG.sub; }
    var total = each * q;
    var perMo = total / t.months / q;
    return {q:q, b:b, total:total, perMo:perMo, perDay:perMo / PACK,
            anchor:t.v.price / t.months, saved:t.v.price * q - total, save:Math.round((1 - each / t.v.price) * 100),
            single:Math.round((1 - t.v.sub / t.v.price) * 100)};
  }

  // One-time is the lesser option: a compact, quieter card (asw-plan--otp), still in the navy system when chosen.
  // It always shows a red-cross "Free shipping", the same ✕ the other buy boxes use, because only the plans ship free.
  function otpHTML(t){
    var sel = st.sel === 'otp', q = st.qty, each = q > 1 ? ' each' : '';
    return '<div class="asw-plan asw-plan--otp'+(sel ? ' sel' : '')+'" role="radio" tabindex="0" aria-checked="'+sel+'" data-k="otp">'
      + '<div class="asw-row"><span class="asw-radio"><b></b></span>'
      + '<div class="asw-pl"><div class="asw-tl"><h4 class="asw-h">One-time purchase</h4></div>'
      + '<p class="asw-noship"><span class="asw-x" aria-hidden="true">✕</span><span class="asw-vh">No </span>Free shipping</p>'
      + (sel ? '<p class="asw-subt">Ships once · no subscription</p>' : '')+'</div>'
      + '<div class="asw-pr"><span class="asw-permo asw-h">'+m(t.v.price)+'<em>'+each+'</em></span></div></div>'
      + '</div>';
  }

  function planHTML(t){
    if (t.key === 'otp') return otpHTML(t);
    var sel = st.sel === t.key, c = calc(t), each = c.q > 1 ? ' each' : '';
    var keys = KIT[t.key] || [], n = keys.length, monthly = t.months === 1, packs = c.q * t.months, hasKit = t.key === KIT_KEY;
    var items = keys.map(gd);
    var tiles = items.map(function(x){
      return '<div class="asw-tile"><div class="asw-img">'+pic(x)+'</div><span class="asw-tname">'+x.label+'</span>'+val(x)+'</div>';
    }).join('');
    var pill = n ? '<span class="asw-giftPill">'+n+' free gift'+(n > 1 ? 's' : '')+'</span>' : '';
    var kit = (sel && hasKit && n) ? '<div class="asw-kit"><div class="asw-kitHead"><div><h5 class="asw-h">Welcome kit</h5>'
      + '<p class="asw-sub">Arrives with your first order.</p></div>'
      // The "N free gifts" pill sits here, where Warren's unwanted "Worth $X" pill was (Oct 9), so the
      // open card's top is just title + billing line. The saving itself is in the band.
      + pill+'</div>'
      + '<div class="asw-tiles">'+tiles+'</div></div>' : '';
    var giftRow = (sel && !hasKit && n) ? '<div class="asw-giftRow"><div class="asw-gthumb">'+SHIP+'</div>'
      + '<div><span class="asw-lord">Your free gift</span><span class="asw-lname">Free shipping on every order</span></div></div>' : '';
    // Noah, Oct 14: the plans renew every 28 / 84 days (a bag is 28 packs), and checkout says so; "every
    // month" / "every 3 months" here contradicted it.
    var ticks = [(monthly ? 'Ships every 28 days' : 'Ships every 84 days'),
      'Lock in your '+c.save+'% savings',
      c.b ? c.save+'% off for '+c.q+', instead of '+c.single+'%' : null,
      // Warren's wording, Oct 9 (one pouch, not one pack).
      PACK+' Daily Packs | '+(PACK * PER)+' Gummies | 1-Month Supply',
      'Pause, skip or cancel any time'].filter(Boolean);
    return '<div class="asw-plan'+(sel ? ' sel' : '')+'" role="radio" tabindex="0" aria-checked="'+sel+'" data-k="'+t.key+'">'
      // The percent rides in the band ("Best deal · Save 45%"): a pill beside the title crowded it on phones.
      + (t.band ? '<div class="asw-band">'+t.band+' · Save '+c.save+'%</div>' : '')
      + '<div class="asw-row"><span class="asw-radio"><b></b></span>'
      + '<div class="asw-pl"><div class="asw-tl"><h4 class="asw-h">'+(monthly ? 'Monthly subscription' : '3-month subscription')+'</h4></div>'
      + '<p class="asw-subt">'+m(c.total)+(monthly ? ' every 28 days' : ' every 84 days')+' · '+packs+' pack'+(packs > 1 ? 's' : '')+'</p>'
      // Tag row under the billing line: the dollar saving (against full price for the same packs) and, on a
      // collapsed card, the gifts teaser. An open card shows its gifts below (kit header or gift row).
      + ((c.saved > 0 || !sel) && (c.saved > 0 || pill) ? '<div class="asw-tags">'
        + (c.saved > 0 ? '<span class="asw-saved">You save '+m(c.saved)+'</span>' : '')+(sel ? '' : pill)+'</div>' : '')
      + '</div>'
      + '<div class="asw-pr"><div class="asw-priceLine"><span class="asw-mrp">'+m(c.anchor)+'</span>'
      + '<span class="asw-permo asw-h">'+m(c.perMo)+'<em>/mo'+each+'</em></span></div>'
      + '<div class="asw-perday">'+m2(c.perDay)+' a day'+each+'</div></div></div>'
      + (sel ? '<div class="asw-detail"><ul class="asw-ticks">'
        + ticks.map(function(x){ return '<li>'+TICK+'<span>'+x+'</span></li>'; }).join('')+'</ul>'+giftRow+kit+'</div>' : '')
      + '</div>';
  }

  function render(){
    var otp = st.sel === 'otp', q = st.qty, due, avail;
    if (otp) { var o = tier('otp').v; due = o.price * q; avail = o.available; }
    else { var t = tier(st.sel); due = calc(t).total; avail = t.v.available; }
    // The 2+ tag shows the real total saving for 2 on the chosen plan (Noah, Oct 29): "+5% off" read as 5 more points
    // (47% -> 52%) when it is 5% off the price (47% -> 50%). Hidden on one-time: 2+ pricing is plans only.
    var t2 = otp ? null : tier(st.sel), save2 = null;
    if (t2) {
      var each2 = AG ? AG.duo : Math.round(t2.v.sub * (1 - (BUNDLE[t2.key] || 0)));
      save2 = Math.round((1 - each2 / t2.v.price) * 100);
    }
    var qb = [1, 2].map(function(v){ return '<button type="button" class="asw-q" data-q="'+v+'" aria-pressed="'+(q === v)+'">'+v
      + (v === 2 && BUNDLE_LIVE && save2 ? '<small class="asw-qbadge">Save '+save2+'%</small>' : '')+'</button>'; }).join('');
    root.innerHTML =
        '<div class="asw-qty"><div class="asw-qlab"><h3 class="asw-h">How many '+noun+'?</h3>'
      + (BUNDLE_LIVE ? '<span class="asw-hint">Buy more, save more</span>' : '')+'</div>'
      + '<div class="asw-qopts">'+qb+'</div></div>'
      + '<h3 class="asw-groupHead asw-h">Choose your plan</h3>'
      + '<div class="asw-plans" role="radiogroup" aria-label="Choose your plan">'+tiers.map(planHTML).join('')+'</div>'
      + '<div class="asw-buy">'
      + '<button type="button" class="asw-cta asw-h"'+(avail && !st.busy ? '' : ' disabled')+'><span>'
      + (st.busy ? 'Loading' : (avail ? 'Checkout' : 'Sold out'))+'</span>'+(avail && !st.busy ? '<span class="asw-ctaPrice">· '+m2(due)+'</span>' : '')+'</button>'
      + (st.err ? '<p class="asw-err" role="alert">'+esc(st.err)+'</p>' : '')
      // Rahi's brief: existing subscribers manage their plan in Loop's portal instead of buying again.
      + '<p class="asw-manage">Already subscribed? <a href="'+ROOT+'a/loop_subscriptions/customer">Manage it here</a></p>'
      + '</div>';
  }

  function add(){
    if (st.busy) return;
    var item, extras = [], flat = 0;
    if (st.sel === 'otp') item = {id: tier('otp').v.id, quantity: st.qty};
    else {
      var t = tier(st.sel);
      item = {id: t.v.id, quantity: st.qty * (t.v.units || 1), selling_plan: t.v.plan};
      // Aggressive offer on a flat-priced plan ($44 / $40): the plan charges the price itself, no code.
      if (AG) { var fp = calc(t).b ? AG.duoPlan : AG.plan; if (fp) { item.selling_plan = fp; flat = calc(t).total; } }
      if (t.key === KIT_KEY) extras = KIT_ADD.map(function(id){ return {id: id, quantity: 1, parent_id: t.v.id}; });
    }
    st.busy = true; st.err = ''; render();
    function post(items){
      return fetch(ROOT + 'cart/add.js', {
        method: 'POST',
        headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
        body: JSON.stringify({items: items})
      }).then(function(r){ return r.json().then(function(j){
        if (!r.ok) throw new Error(j.description || j.message || 'Could not add to cart');
        return j;
      }); });
    }
    // Straight to checkout, no cart (Warren, Oct 6). With no cart page to review, the cart is emptied
    // first so checkout holds only this selection.
    // 2 people on a plan: Shopify's DUO code takes the extra 5 points off (see BUNDLE). Codes only
    // reach checkout via /discount/. Any other add drops a leftover DUO code so a solo 3-month
    // (3 packs, past the code's minimum of 2) can't keep the 2-person price.
    var bundled = st.sel !== 'otp' && calc(tier(st.sel)).b > 0;
    var code = bundled ? DUO : null;
    // Offer codes our pages set: both DUO codes, the First Offer ones (FO45SUB, FO50SUB, firstoffer30/40) and the
    // landers' (save30adults/save35adults on Mens, Beauty, Nutrition Support). One left on the session takes its
    // discount off every pack of a 3-month plan too (order #4311), so they all go. Other codes (influencer links) stay.
    var OURS = /^(DUOADULTS|DUOKIDS|FO\d+SUB|FIRSTOFFER\d+|SAVE\d+ADULTS)$/;
    // Shopify also keeps the last /discount/ code in a discount_code cookie, and checkout re-applies it even after
    // cart/update.js drops it from the cart (Oct 20: FO45SUB took the Winks $51.99 to $43.49). Ours go; others stay.
    function dropOurCookie(){
      var m = document.cookie.match(/(?:^|;\s*)discount_code=([^;]*)/);
      if (m && OURS.test(decodeURIComponent(m[1]).toUpperCase())) ['', '; domain=' + location.hostname, '; domain=.' + location.hostname.replace(/^www\./, '')].forEach(function(d){ document.cookie = 'discount_code=; Max-Age=0; path=/' + d; });
    }
    // Aggressive offer: every subscription needs its code (it's what takes the plan to $44 / $40).
    // 2+ people: a flat-priced plan per tier ($49 monthly, $38.50 a bag for 3 months) instead of the DUO
    // code, so checkout's "Recurring subtotal" shows the real price. Only plans the product has; else the code.
    var duoPlan = !AG && bundled ? (st.sel === 'one' ? D.oneDuoPlan : st.sel === 'three' ? D.threeDuoPlan : null) : null;
    if (duoPlan) { item.selling_plan = duoPlan; flat = calc(tier(st.sel)).total; code = null; }
    if (AG) {
      code = st.sel === 'otp' || flat ? null : (bundled ? AG.duoCode : AG.code);
    }
    var CHECKOUT = ROOT + 'checkout';
    function finish(){
      var go = function(){
        dropOurCookie();
        window.location.href = code ? ROOT + 'discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(CHECKOUT) : CHECKOUT;
      };
      // Aggressive offer: drop any code left from an earlier visit first. /discount/ adds to the cart's codes,
      // so 1 adult then 2 would keep FO45SUB next to FO50SUB and stack them if they combine ($31.50 a pack).
      if (code && AG) return fetch(ROOT + 'cart/update.js', {method: 'POST', headers: {'Content-Type': 'application/json'}, body: JSON.stringify({discount: ''})}).catch(function(){}).then(go);
      // Everything else, DUO included, drops a leftover offer code first for the same reason.
      return fetch(ROOT + 'cart.js').then(function(r){ return r.json(); }).then(function(c){
        // No price check before checkout (Noah, Oct 20): a shopper at checkout on the wrong price beats one
        // turned away. The old check compared the discounted line, so a leftover offer code (FO45SUB took $44 to
        // $35.50) showed "not set up yet" on a working offer. Plan prices are checked on live after each change.
        var has = (c.discount_codes || []).some(function(d){ return OURS.test(String(d.code).toUpperCase()); });
        if (has) return fetch(ROOT + 'cart/update.js', {method: 'POST', headers: {'Content-Type': 'application/json'}, body: JSON.stringify({discount: ''})});
      }).catch(function(){}).then(go);
    }
    fetch(ROOT + 'cart/clear.js', {method: 'POST', headers: {'Content-Type': 'application/json', 'Accept': 'application/json'}, body: '{}'})
    .catch(function(){})
    .then(function(){ return post([item].concat(extras)); })
    .catch(function(e){ if (!extras.length) throw e; return post([item]); })
    .then(finish)
    .catch(function(e){ st.busy = false; st.err = e.message; render(); });
  }

  root.addEventListener('click', function(e){
    var el = e.target.closest('[data-q],[data-k],.asw-cta');
    if (!el || !root.contains(el)) return;
    if (el.hasAttribute('data-q')) { st.qty = +el.getAttribute('data-q'); st.err = ''; render(); }
    else if (el.classList.contains('asw-cta')) { add(); }
    else if (st.sel !== el.getAttribute('data-k')) { st.sel = el.getAttribute('data-k'); st.err = ''; render(); }
  });
  root.addEventListener('keydown', function(e){
    if (e.key !== 'Enter' && e.key !== ' ') return;
    var el = e.target.closest('[data-k]');
    if (!el) return;
    e.preventDefault(); st.sel = el.getAttribute('data-k'); st.err = ''; render();
    var f = root.querySelector('[data-k="'+st.sel+'"]'); if (f) f.focus();
  });
  // Back from checkout restores this page from the back/forward cache with the button still
  // on "Loading" (busy is never cleared on success, the page just leaves). Reset it.
  window.addEventListener('pageshow', function(e){
    if (e.persisted && st.busy) { st.busy = false; st.err = ''; render(); }
  });

  render();
}

function boot(){ document.querySelectorAll('.asw[data-asw]').forEach(init); }
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
